import { useDispatch } from 'react-redux'
import { useToggleReviewLikedMutation } from '@/graphql/generated/hooks'
import { doSetGlobalToastContent } from '@/stores/reduxUI'
import { encodeId } from '@/utils/utilApi'
import { ApiErrorUtils } from '@/utils/utilApiErrors'

export const useReviewToggleLikedMutation = () => {
  const [toggleReviewLikedMutation] = useToggleReviewLikedMutation()
  const dispatch = useDispatch()

  const toggleReviewLiked = async (reviewId: number) => {
    try {
      const { data, errors } = await toggleReviewLikedMutation({
        variables: {
          id: encodeId('ReviewType', reviewId), // base64 encoded
        },
      })

      if (errors) {
        const errorInfo = ApiErrorUtils.getError(errors[0])
        throw new Error(errorInfo.message)
      }
      return data?.toggleReviewLiked?.review
    } catch (error) {
      const errorInfo = ApiErrorUtils.getError(error)
      dispatch(
        doSetGlobalToastContent({
          content: `${errorInfo.message}\n오류가 지속된다면 고객센터에 문의해 주세요`,
          duration: 5,
        })
      )
      return null
    }
  }

  return {
    toggleReviewLiked,
  }
}
